import React from 'react';
import { Box, Flex, Text } from 'pcln-design-system';
import { Pin } from 'pcln-icons';
const Header = ({
  hotelName,
  neighborhoodName
}) => {
  return React.createElement(Box, null, React.createElement(Text, {
    fontWeight: 'bold',
    fontSize: 1,
    lineHeight: '19px'
  }, hotelName), React.createElement(Flex, {
    py: 1,
    alignItems: 'center'
  }, React.createElement(Pin, {
    color: 'primary.base',
    size: 16
  }), React.createElement(Text, {
    fontSize: 0,
    lineHeight: '16px',
    color: 'primary.base',
    ml: 1
  }, neighborhoodName)));
};
export default Header;